/* eslint-disable jsx-a11y/anchor-is-valid */
import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import ClaimStatus from '../../../../ClaimStatus';
import Currency from '../../../../Currency';

function claimNumber(original, props, accessorFunctionsAdditional) {
  const { setCurrentClaimId, setOpen } = accessorFunctionsAdditional;
  return (
    <Link
      onClick={() => {
        setCurrentClaimId(original.id, setOpen(true));
      }}>
      {original?.claimNumber}
    </Link>
  );
}

function claimStatus(original) {
  return <ClaimStatus>{original?.claimStatus}</ClaimStatus>;
}

function totalAmountApproved(original) {
  return <Currency>{original?.totalAmountApproved}</Currency>;
}

function createdDateTime(original) {
  return original?.createdDateTime
    ? dayjs(original?.createdDateTime).format(DATE_FORMAT.LONG_DATE)
    : original?.createdDateTime;
}

function lastModifiedDateTime(original) {
  return original?.lastModifiedDateTime
    ? dayjs(original?.lastModifiedDateTime).format(DATE_FORMAT.LONG_DATE)
    : original?.lastModifiedDateTime;
}

export {
  claimNumber,
  claimStatus,
  totalAmountApproved,
  createdDateTime,
  lastModifiedDateTime,
};
